export const API_BASE_URL =
  (process.env.REACT_APP_API_BASE_URL && process.env.REACT_APP_API_BASE_URL !== '')
    ? process.env.REACT_APP_API_BASE_URL
    : 'http://localhost:8000/api';

export const ADMIN_API_BASE_URL =
  (process.env.REACT_APP_ADMIN_API_BASE_URL && process.env.REACT_APP_ADMIN_API_BASE_URL !== '')
    ? process.env.REACT_APP_ADMIN_API_BASE_URL
    : 'http://localhost:8000/api/admin';

export const CDN_URL =
  (process.env.REACT_APP_CDN_URL && process.env.REACT_APP_CDN_URL !== '')
    ? process.env.REACT_APP_CDN_URL
    : 'http://cdn.localhost:8000';

// Order Statuses
export const ORDER_STATUSES = [
  'pending',
  'confirmed',
  'processing',
  'shipped',
  'delivered',
  'cancelled',
];

// Payment Statuses
export const PAYMENT_STATUSES = ['pending', 'paid', 'failed'];

// Product Statuses
export const PRODUCT_STATUSES = ['active', 'inactive', 'out_of_stock'];

// User Roles
export const USER_ROLES = ['customer', 'admin'];

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'admin_token',
  USER: 'admin_user',
};
